module.exports = __webpack_public_path__ + "img/upload-id.628afd99.jpg";